<template>
  <b-overlay :show="loading">
    <div class="d-flex justify-content-center align-items-center">
      <div v-tooltip="'Ver detalle'">
        <b-button
          variant="secondary"
          class="btn-icon rounded-circle p-3"
          size="sm"
          v-on:click="onOptionDetailBatch(batch)"
          data-cy="details"
        >
          <feather-icon icon="SearchIcon"/>
        </b-button>
      </div>
      <slot
        name="action-list"
        v-bind:batch="batch"
      >
        <div v-tooltip="'Desplegar acciones'">
          <b-dropdown
            v-has-permission="'ED185'"
            variant="link"
            no-caret
            right
          >
            <template #button-content>
              <feather-icon
                data-cy="gear-button"
                width="24px"
                height="24px"
                icon="SettingsIcon"
                class="align-middle text-body"
              />
            </template>
            <CheckPermission permission="ED166">
              <b-dropdown-item
                v-on:click="onOptionBatchBinnacle(batch)"
                data-cy="binnacle"
              >
                <vs-icon icon="list"/>
                Bitácora
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED170" v-if="view !== 'batchs-review'">
              <b-dropdown-item
                v-if="EDIT_STATES.includes(batch.estado)"
                data-cy="edit"
                @click="onOptionEditBatch(batch)"
              >
                <vs-icon icon="edit"/>
                Editar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED171">
              <b-dropdown-item
                v-on:click="onOptionVisualizeBatch(batch)"
                data-cy="visualize"
              >
                <vs-icon icon="content_paste"/>
                Visualizar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED167">
              <b-dropdown-item
                data-cy="approve"
                v-if="APPROVE_STATES.includes(batch.estado) && view === 'batchs-review'"
                v-on:click="onOptionBatchAprove(batch)"
              >
                <vs-icon icon="thumb_up"/>
                Aprobar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED186">
              <b-dropdown-item
                data-cy="cancel"
                v-if="REJECT_STATES.includes(batch.estado) && view === 'batchs-review'"
                v-on:click="onOptionBatchReject(batch)"
              >
                <vs-icon icon="thumb_down"/>
                Rechazar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED168" v-if="view !== 'batchs-review'">
              <b-dropdown-item
                data-cy="rescue"
                v-if="RESCUE_STATES.includes(batch.estado)"
                v-on:click="onOptionBatchRescue(batch)"
              >
                <vs-icon icon="assessment"/>
                Rescatar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="*" v-if="view !== 'batchs-review'">
              <b-dropdown-item
                data-cy="main-photo"
                v-if="EDIT_STATES.includes(batch.estado)"
                v-on:click="onOptionBatchPicture(batch)"
              >
                <vs-icon icon="photo"/>
                Imágenes
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED173" v-if="view !== 'batchs-review'">
              <b-dropdown-item
                data-cy="apply-auction"
                v-on:click="onOptionBatchPostule(batch)"
                v-if="POSTULE_STATES.includes(batch.estado)"
              >
                <vs-icon icon="add_circle"/>
                Agregar a subasta
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED169"
              v-if="batch.estado === batchesCodeSates.creado && view !== 'batchs-review'"
            >
              <b-dropdown-item
                data-cy="validate"
                v-on:click="onOptionValidateBatch(batch, batchesActionStates.VALIDAR)"
              >
                <vs-icon icon="verified_user"/>
                Validar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED187"
              v-if="batch.estado === batchesCodeSates.publicado &&
              view !== 'batchs-review' &&
              !canReturn"
            >
              <b-dropdown-item
                data-cy="adjudge"
                v-on:click="onOptionPopUpAdjudge(batch)"
              >
                <vs-icon icon="attach_money"/>
                Adjudicar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED172"
              v-if="view !== 'batchs-review'"
            >
              <b-dropdown-item
                data-cy="cancel"
                v-if="CANCEL_STATES.includes(batch.estado)"
                v-on:click="onOptionBatchCancel(batch)"
              >
                <vs-icon icon="highlight_off"/>
                Anular
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED220"
              v-if="view !== 'batchs-review'"
            >
              <b-dropdown-item
                data-cy="return"
                v-if="canReturn"
                v-on:click="onOptionBatchReturn(batch)"
              >
                <vs-icon icon="replay"/>
                Devolver
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED225"
              v-if="view !== 'batchs-review'"
            >
              <b-dropdown-item
                data-cy="donate"
                v-if="canDonate"
                v-on:click="onOptionBatchDonate(batch)"
              >
                <vs-icon icon="store"/>
                Donar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED226"
              v-if="view !== 'batchs-review'"
            >
              <b-dropdown-item
                data-cy="destroy"
                v-if="canDonate"
                v-on:click="onOptionBatchDestroy(batch)"
              >
                <vs-icon icon="delete"/>
                Destruir
              </b-dropdown-item>
            </CheckPermission>
          </b-dropdown>
        </div>
      </slot>
    </div>
    <b-modal
      :id="`batch-detail-${batch.loteId}`"
      :title="`Detalles del Lote Nº ${batch.folio}`"
      no-close-on-backdrop
      :ref="`batch-detail-${batch.loteId}`"
      size="lg"
      hide-footer
    >
      <BatchDetail :batch="batch"/>
    </b-modal>
    <b-modal
      :id="`batch-rescue-${batch.loteId}`"
      :title="`¿Realmente desea Rescatar el Lote N° ${batch.folio}?`"
      no-close-on-backdrop
      :ref="`batch-rescue-${batch.loteId}`"
      size="md"
      hide-footer
    >
      <BatchRescue
        :batch="batch"
        @rescue="onRescueBatch"
      />
    </b-modal>
    <b-modal
      :id="`batch-picture-${batch.loteId}`"
      :title="`Imágenes adjuntas de Lote N° ${batch.folio}`"
      no-close-on-backdrop
      :ref="`batch-picture-${batch.loteId}`"
      size="lg"
      hide-footer
    >
      <BatchPicture
        @close-modal="closeModal()"
        @edit-images="onEditBatch()"
        :batch="batch"
      />
    </b-modal>
    <b-modal
      :id="`batch-postule-${batch.loteId}`"
      :ref="`batch-postule-${batch.loteId}`"
      :title="`Agregar Lote N° ${batch.folio} a subasta` "
      no-close-on-backdrop
      size="xl"
      hide-footer
    >
      <BatchPostule
        :batch-ids="[batch.loteId]"
        @postule="handleOnPostule"
      />
    </b-modal>
    <b-modal
      :id="`batch-cancel-${batch.loteId}`"
      :ref="`batch-cancel-${batch.loteId}`"
      :title="`Anular Lote N° ${batch.folio}`"
      hide-footer
    >
      <BatchCancel
        :batch="batch"
        @cancel="handleOnCancel"
      />
    </b-modal>
    <b-modal
      :id="`batch-reject-${batch.loteId}`"
      :ref="`batch-reject-${batch.loteId}`"
      :title="`Rechazar Lote N° ${batch.folio}`"
      hide-footer
    >
      <BatchReject
        :batch="batch"
        @cancel="handleOnReject"
      />
    </b-modal>
    <b-modal
      :id="`batch-approve-${batch.loteId}`"
      :ref="`batch-approve-${batch.loteId}`"
      :title="`Aprobar Lote N° ${batch.folio}`"
      hide-footer
    >
      <BatchApprove
        :batch="batch"
        @approve="handleOnApprove"
      />
    </b-modal>
    <b-modal
      :id="`batch-adjudge-${batch.loteId}`"
      :title="`Adjudicación de Lote Nº ${batch.folio}`"
      no-close-on-backdrop
      :ref="`batch-adjudge-${batch.loteId}`"
      size="lg"
      hide-footer>
      <BatchAdjudge
        :batch="batch"
        @adjudge="handleOnAdjudge"
      />
    </b-modal>
    <b-modal
      :id="`batch-return-${batch.loteId}`"
      :title="`Devolver Lote Nº ${batch.folio}`"
      no-close-on-backdrop
      :ref="`batch-return-${batch.loteId}`"
      size="md"
      hide-footer>
      <BatchReturn
        :batch="batch"
        @return="handleOnReturn"
      />
    </b-modal>
    <ModalBinnacle
      :batch="batch"
      :title="`Bitácora del Lote Nº ${batch.folio}`"
      :id="`binnacle-${batch.loteId}`"
      :ref="`binnacle-${batch.loteId}`"
    />
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import BatchDetail from '@/febos/aduanas/batches/views/components/modals/BatchDetail';
import BatchRescue from '@/febos/aduanas/batches/views/components/modals/BatchRescue';
import BatchReject from '@/febos/aduanas/batches/views/components/modals/BatchReject';
import BatchPicture from '@/febos/aduanas/batches/views/components/modals/BatchPicture';
import ModalBinnacle from '@/febos/aduanas/binnacles/ModalBinnacle';
import BatchAdjudge from '@/febos/aduanas/batches/views/components/modals/BatchAdjudge';
import BatchReturn from '@/febos/aduanas/batches/views/components/modals/BatchReturn';
import {
  BatchPostule,
  BatchCancel,
  BatchApprove
} from '@/febos/aduanas/batches/views/components/modals';
import {
  APPROVE_STATES,
  CANCEL_STATES,
  POSTULE_STATES,
  RESCUE_STATES,
  batchesCodeSates,
  REJECT_STATES,
  RETURN_STATES,
  EDIT_STATES,
  batchesActionStates
} from '@/febos/aduanas/batches/views/utils/constants';
import { auctionsStateCode } from '@/febos/aduanas/auctions/views/utils/constants';
import { getBatch } from '@/febos/servicios/api/aduanas/batches.api';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

export default {
  components: {
    CheckPermission,
    BatchDetail,
    BatchRescue,
    BatchPicture,
    BatchPostule,
    BatchReject,
    BatchCancel,
    BatchApprove,
    ModalBinnacle,
    BatchAdjudge,
    BatchReturn
  },
  props: [
    'batch',
    'selectBatch'
  ],
  data() {
    return {
      view: this.$route.name,
      batchesActionStates,
      auctionsStateCode,
      batchesCodeSates,
      POSTULE_STATES,
      REJECT_STATES,
      CANCEL_STATES,
      APPROVE_STATES,
      RESCUE_STATES,
      RETURN_STATES,
      EDIT_STATES,
      loading: false
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    canDonate() {
      return RETURN_STATES.includes(this.batch.estado)
      && this.batch.subasta.estado === auctionsStateCode.finalizada
        && this.batch.subastasCantidad >= 4 && this.batch.devolucionesCantidad === 3;
    },
    canReturn() {
      return RETURN_STATES.includes(this.batch.estado)
        && this.batch.subasta.estado === auctionsStateCode.finalizada
        && this.batch.devolucionesCantidad < 3;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('batches', [
      'attemptUpdateStatusBatch'
    ]),
    onOptionDetailBatch(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-detail-${batch.loteId}`].show();
    },
    onOptionBatchRescue(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-rescue-${batch.loteId}`].show();
    },
    onOptionBatchPicture(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-picture-${batch.loteId}`].show();
    },
    onOptionBatchPostule(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-postule-${batch.loteId}`].show();
    },
    handleOnPostule() {
      this.$refs[`batch-postule-${this.batch.loteId}`].hide();
      this.$emit('reload-list');
    },
    onRescueBatch() {
      this.$refs[`batch-rescue-${this.batch.loteId}`].hide();
      this.$emit('reload-list');
    },
    onEditBatch() {
      this.$emit('reload-list');
    },
    onOptionPopUpAdjudge(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-adjudge-${batch.loteId}`].show();
    },
    onOptionBatchBinnacle(batch) {
      this.selectBatch(batch);
      this.$refs[`binnacle-${batch.loteId}`].show(batch.loteId);
    },
    onOptionEditBatch(batch) {
      this.selectBatch(batch);
      this.$router.push({ name: 'edit-batch', params: { id: batch.loteId } });
    },
    onOptionBatchCancel(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-cancel-${batch.loteId}`].show();
    },
    onOptionBatchReturn(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-return-${batch.loteId}`].show();
    },
    onOptionBatchAprove(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-approve-${batch.loteId}`].show();
    },
    onOptionBatchReject(batch) {
      this.selectBatch(batch);
      this.$refs[`batch-reject-${batch.loteId}`].show();
    },
    onOptionBatchDonate(batch) {
      this.selectBatch(batch);
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas donar el Lote Nº ${batch.folio}?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateBatch(batch, this.batchesActionStates.DONAR)
      });
    },
    onOptionBatchDestroy(batch) {
      this.selectBatch(batch);
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas destruir el Lote Nº ${batch.folio}?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateBatch(batch, this.batchesActionStates.DESTRUIR)
      });
    },
    handleOnCancel() {
      this.$refs[`batch-cancel-${this.batch.loteId}`].hide();
      this.$emit('reload-list');
    },
    handleOnApprove() {
      this.$refs[`batch-approve-${this.batch.loteId}`].hide();
      this.$emit('reload-list');
    },
    handleOnAdjudge() {
      this.$refs[`batch-adjudge-${this.batch.loteId}`].hide();
      this.$emit('reload-list');
    },
    handleOnReturn() {
      this.$refs[`batch-return-${this.batch.loteId}`].hide();
      this.$emit('reload-list');
    },
    handleOnReject() {
      this.$refs[`batch-reject-${this.batch.loteId}`].hide();
      this.$emit('reload-list');
    },
    async updateBatch(batch, action) {
      await this.attemptUpdateStatusBatch({ batchId: batch.loteId, action });
    },
    onOptionValidateBatch(batch, action) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas enviar a revisión el Lote Nº ${batch.folio}?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateBatch(batch, action)
      });
    },
    async onOptionVisualizeBatch(batch) {
      this.$vs.notify({
        title: 'Hola!',
        text: 'Estamos buscando el archivo, danos unos segundos',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'primary',
        position: ALERT_POSITION
      });
      const { data } = await getBatch({
        loteId: batch.loteId,
        pdf: 'si'
      });
      window.open(data.url, '_blank');
    },
    closeModal() {
      if (this.$refs[`batch-picture-${this.batch.loteId}`]) {
        this.$refs[`batch-picture-${this.batch.loteId}`].hide();
      }
      this.$emit('reload-list');
    }
  }
};

</script>
